module.exports = __webpack_public_path__ + "img/08.ad347867.png";